// cell renderers and other 'framework components' to be used in ag-grid
// assume they will all get a prop of 'params'
/*
inside the parent component that uses these, you should pass in the parent component instance so these components can access it:
    this.gridOptions = {
        context: {
            componentParent: this,
        },
        ... and more

then these child 'framework components' can access 'parent' component via this.params.context.componentParent
*/

/*
when using these, you need to:
0) Write them with Vue.extend({}) syntax instead of component!  then you don't have to declare them in components: {} option, avoiding any linting errors
1) import them in the file where you're using ag-grid
2) DO NOT declare them in components: {} option -- since you're using Vue.extend() instead
3) register them in this.gridOptions.frameworkComponents (someComponentName: SomeComponentName)
4) use it somewhere, like in columnDefs.cellRenderer = 'someComponentName'   (note cellRenderer instead of just cellRendererFramework, since you're putting them in frameworkComponents)
... if you didn't use frameworkComponents, you could use them directly (as STRINGS) like cellRendererFramework: 'MyComponent' -- but then you run into linting problems with unused components
*/

import Vue from 'vue';

var CheckboxCellRenderer = Vue.extend({
    //name: 'CheckboxCellRenderer',
    //data: function() { return {} },
    methods: {
        checkedHandler(event) {
            let checked = event.target.checked;
            let colId = this.params.column.colId;
            this.params.node.setDataValue(colId, checked);
        }
    },
    template: `
        <input 
            type="checkbox" 
            @click="checkedHandler($event)"
            :checked="params.value"
        />
    `
})

const DownloadLinkRenderer = Vue.extend({
    // can pass in params.linkText also
    template: `
        <div>
            <a :href="params.value" target="_blank" class="btn btn-subtle-primary btn-sm">{{ params.linkText || 'Download Link' }}</a>
        </div>
    `
})

const FileDownloadBadgeRenderer = Vue.extend({
    // just an ag-grid specific wrapper around my normal FileDownloadBadge vue component, which is designed for rendering things from S3File serializers
    template: `
        <div class="p-2">
            <file-download-badge
                :fileData="params.value"
                button-variant="subtle-primary"
                hide-download-icon
            ></file-download-badge>
        </div>
    `
});

const MultipleFileDownloadButtonRenderer = Vue.extend({
    // just an ag-grid specific wrapper around my normal BaseS3FileDownloadButtonGroup vue component, which is designed for rendering list of S3Files
    // params.value is expected to be a list of S3File objects (full objects, not just IDs)
    // we set w-100 here so they expand to fill the width of the cell, so they all look similar side-by-side
    template: `
        <div class="p-2 d-flex flex-column gap-2 align-items-center">
            <base-s-3-file-download-button-group
                :fileData="params.value"
                bundleDownloadLocation="below"
                :button-props="{
                    block: false,
                    buttonVariant: 'subtle-primary',
                    hideFilesize: false,
                }"
                vertical
                class="w-100"
            ></base-s-3-file-download-button-group>
        </div>
    `
});


export {
    CheckboxCellRenderer,
    DownloadLinkRenderer,
    FileDownloadBadgeRenderer,
    MultipleFileDownloadButtonRenderer,
}